import type { BackgroundMedia, PageDefinition } from '@wix/thunderbolt-becky-types'
import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api'
import type { PageTransitionsPageConfig } from '../types'
import { name } from '../symbols'

function resolvePageBackground(
	pageData: PageDefinition['data'] | undefined,
	viewMode: 'mobile' | 'desktop'
): BackgroundMedia | undefined {
	const modeData = pageData?.pageBackgrounds?.[viewMode] as { ref?: BackgroundMedia } | undefined
	return modeData?.ref
}

const pageTransitionsPageConfig: PageConfigFn<PageTransitionsPageConfig> = ({ api }: VsmContext, pageId: string) => {
	const isMasterPage = pageId === 'masterPage'
	// Use page.getPageData so we get document_data[pageId] directly; getCompData depends on structure.dataQuery
	const pageData = api.page.getPageData(pageId) as PageDefinition['data'] | undefined
	const isRoutable = pageData ? api.page.isRoutablePage(pageData) : false
	const transitionName = api.page.getPageTransition()
	const viewMode = api.env.isMobileView() ? ('mobile' as const) : ('desktop' as const)

	const shouldLoadPageFeature = !isMasterPage && isRoutable && transitionName !== null && transitionName !== 'none'

	if (!shouldLoadPageFeature) {
		return { shouldLoadPageFeature: false }
	}

	const experiments = api.env.getExperiments()
	const shouldUseViewTransition =
		experiments?.['specs.thunderbolt.shouldUseViewTransition'] === true ||
		experiments?.['specs.thunderbolt.shouldUseViewTransition'] === 'true'
	const useCssFeatureForViewTransitions =
		experiments?.['specs.thunderbolt.mpaViewTransitionsCssFeature'] === true ||
		experiments?.['specs.thunderbolt.mpaViewTransitionsCssFeature'] === 'true'

	const pageBackground = resolvePageBackground(pageData, viewMode)

	return {
		shouldLoadPageFeature: true,
		pageConfig: {
			shouldUseViewTransition,
			useCssFeatureForViewTransitions,
			transitionName: transitionName!,
			pageBackground: pageBackground as BackgroundMedia,
			viewMode,
			isEditor: false,
			isPreview: false,
		},
	}
}

export const pageConfig: PageConfigEntry<PageTransitionsPageConfig> = {
	name,
	configFactory: pageTransitionsPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
